export default __webpack_public_path__ + "5b8799d06d627ea3b38700d75d5ae983.png";